module.exports = __webpack_public_path__ + "img/discover-dark.024c865d.svg";